import { isStrayCypherExpr } from './stray'

/**
 * Detail bundle for a single `:Utility` (`$utilityId` param).
 *
 * Returns one row:
 *   - `u`          — the Utility node
 *   - `consumers`  — inbound `REQUIRES_UTILITY` rows `{ equipment, edge }`
 *                    (standard `extractPlantEdges` edge shape)
 *   - `site` / `line` — Factory crumb context from direct ownership via
 *                    `(Site|Line)-[:HAS_UTILITY]->(u)`. A Line owner resolves
 *                    its Site through the usual parent-subline walk.
 *
 * Bounded by `LIMIT 10000`.
 */
export const PLANT_UTILITY_DETAIL_CYPHER = `
  MATCH (u:Utility {id: $utilityId})

  CALL {
    WITH u
    OPTIONAL MATCH (eq:Equipment)-[e:REQUIRES_UTILITY]->(u)
    RETURN [row IN collect(DISTINCT {
             equipment: eq,
             edge: {
               type: type(e),
               source: eq.id,
               target: u.id,
               props: properties(e)
             }
           }) WHERE row.equipment IS NOT NULL] AS consumers
  }

  CALL {
    WITH u
    OPTIONAL MATCH (lineOwner:Line)-[:HAS_UTILITY]->(u)
    WITH u, head(collect(DISTINCT lineOwner)) AS line
    OPTIONAL MATCH (siteOwner:Site)-[:HAS_UTILITY]->(u)
    WITH u, line, head(collect(DISTINCT siteOwner)) AS directSite
    OPTIONAL MATCH (line)<-[:HAS_SUBLINE*0..20]-(:Line)<-[:HAS_LINE]-(lineSite:Site)
    WITH line, directSite, head(collect(DISTINCT lineSite)) AS lineSite
    RETURN line, coalesce(directSite, lineSite) AS site
  }

  RETURN u, consumers, site, line,
         ${isStrayCypherExpr('u', 'Utility')} AS isStray
  LIMIT 10000
`
